import { render, staticRenderFns } from "./DiscoverView.vue?vue&type=template&id=43a58b7c&scoped=true&"
import script from "./DiscoverView.vue?vue&type=script&lang=ts&"
export * from "./DiscoverView.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverView.vue?vue&type=style&index=0&id=43a58b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a58b7c",
  null
  
)

export default component.exports